import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('LawyerLevel')
export class LawyerLevel {
    @JsonProperty('id', Number, true)
    id: number = undefined;

    @JsonProperty('name', String, true)
    name = '';

    @JsonProperty('name_ar', String, true)
    nameAr = '';

    @JsonProperty('rate', Number, true)
    rate: number = undefined;

    @JsonProperty('commission_rate_nm', Number, true)
    commissionRateNM: number = undefined;

    @JsonProperty('commission_rate_nc', Number, true)
    commissionRateNC: number = undefined;

    get getName() {
        return this.name || this.nameAr;
    }

}